module.exports = __webpack_public_path__ + "img/dimsum-cutted.26524d0f.png";